import { ModuleWithProviders, NgModule } from '@angular/core';
import { BreadcrumbBuilder } from './breadcrumb-builder';
import { BreadcrumbComponent } from './breadcrumb.component';
import { CampaignUtilModule } from '../../../module/campaign-util/campaign-util.module';
import { CommonModule } from '@angular/common';
import { UiModule } from '../ui.module';

@NgModule({
  declarations: [
    BreadcrumbComponent
  ],
  exports: [
    BreadcrumbComponent
  ],
  imports: [
    CampaignUtilModule,
    CommonModule,
    UiModule
  ]
})
export class BreadcrumbModule {

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: BreadcrumbModule,
      providers: [
        {
          provide: BreadcrumbBuilder,
          useValue: new BreadcrumbBuilder()
        }
      ]
    };
  }
}
